import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { isNull } from '@hcr/utils'

import { useHoliday } from '../../../contexts'
import { BookingOverview, LayoutNavigationError500, Metadata } from '../../common'

import { BookingEmpty } from './BookingEmpty'
import { LayoutBooking } from './common'

export const Booking: FC = () => {
  const { t } = useTranslation()
  const holiday = useHoliday()

  if (holiday.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (holiday.isSuccess && isNull(holiday.data.accommodationId)) {
    return <BookingEmpty />
  }

  return (
    <LayoutBooking>
      <Metadata title={t('page-title.booking')} />
      <BookingOverview />
    </LayoutBooking>
  )
}
